import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import SharedGPAto100 from "./SharedGPAto100";
import Shared100toGPA from "./Shared100toGPA";
import SharedGPA4to5 from "./SharedGPA4to5";
import SharedGPA5to4 from "./SharedGPA5to4";
import Shared100toGPA5 from "./Shared100toGPA5";
import SharedGPA5to100 from "./SharedGPA5to100";
import SharedGradeUk from "./SharedGradeUk";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
import GPAPlanner from "./SharedGPAPlanner";
const TITLE = "Calcul de la moyenne cumulative - Calcul de la moyenne universitaire";
const DESCRIPTION =
  "Calcul de la moyenne cumulative - Calcul de la moyenne universitaire pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "calcul de la moyenne cumulative calcul de la moyenne universitaire, calculatrice calcul de la moyenne cumulative calcul de la moyenne universitaire, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gpagrade";
function GradeGPACalculator() {
  const [courses, setCourses] = useState([
    { name: "Mathématiques", credits: "3", grade: "A" },
    { name: "Physique", credits: "2", grade: "B+" },
    { name: "Informatique", credits: "3", grade: "A-" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gpa, setGPA] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const gradeOptions = [
    "A+",
    "A",
    "A-",
    "B+",
    "B",
    "C+",
    "C",
    "D+",
    "D",
    "D-",
    "F",
  ];
  const addCourse = () => {
    setCourses([...courses, { name: "", credits: "", grade: "A+" }]);
  };
  const removeCourse = (index) => {
    const updatedCourses = [...courses];
    updatedCourses.splice(index, 1);
    setCourses(updatedCourses);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedCourses = [...courses];
    updatedCourses[index][name] = value;
    setCourses(updatedCourses);
  };
  const calculate = () => {
    setIsLoading(true);
    setError(null);
    let totalGradePoints = 0;
    let creditsSum = 0;
    for (const course of courses) {
      const credits = parseFloat(course.credits);
      const grade = course.grade;
      if (!isNaN(credits)) {
        const gradePoints = calculateGradePoints(grade);
        if (!isNaN(gradePoints)) {
          totalGradePoints += credits * gradePoints;
          creditsSum += credits;
        }
      }
    }
    if (creditsSum === 0) {
      setError("Entrez des valeurs valides");
    } else {
      const calculatedGPA = totalGradePoints / creditsSum;
      setGPA(calculatedGPA.toFixed(2));
      setTotalCredits(creditsSum);
    }
    setIsLoading(false);
  };
  const calculateGradePoints = (grade) => {
    let gradePoints;
    const gradeMap = {
      "A+": 4.0,
      A: 4.0,
      "A-": 3.7,
      "B+": 3.3,
      B: 3.0,
      "B-": 2.7,
      "C+": 2.3,
      C: 2.0,
      "C-": 1.7,
      "D+": 1.3,
      D: 1.0,
      "D-": 0.7,
      F: 0.0,
    };
    if (grade === "F") {
      gradePoints = 0;
    } else {
      gradePoints = gradeMap[grade] || NaN;
    }
    return gradePoints;
  };
  const calculateLetterGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "A+";
    } else if (gpa >= 3.7) {
      return "A";
    } else if (gpa >= 3.3) {
      return "A-";
    } else if (gpa >= 3.0) {
      return "B+";
    } else if (gpa >= 2.7) {
      return "B";
    } else if (gpa >= 2.3) {
      return "B-";
    } else if (gpa >= 2.0) {
      return "C+";
    } else if (gpa >= 1.7) {
      return "C";
    } else if (gpa >= 1.3) {
      return "C-";
    } else if (gpa >= 1.0) {
      return "D+";
    } else if (gpa >= 0.7) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateNumericalGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "97–100";
    } else if (gpa >= 3.7) {
      return "94–96";
    } else if (gpa >= 3.3) {
      return "90–93";
    } else if (gpa >= 3.0) {
      return "87–89";
    } else if (gpa >= 2.7) {
      return "84–86";
    } else if (gpa >= 2.3) {
      return "80–83";
    } else if (gpa >= 2.0) {
      return "77–79";
    } else if (gpa >= 1.7) {
      return "74–76";
    } else if (gpa >= 1.3) {
      return "67–69";
    } else if (gpa >= 1.0) {
      return "64–66";
    } else if (gpa >= 0.7) {
      return "60–63";
    } else {
      return "0–59";
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                La calculatrice de moyenne universitaire calcule le GPA cumulatif et calcule ce qui suit:
                <ul>
                  <li>Calcul du GPA cumulatif</li>
                  <li>Calcul de la moyenne cumulative sur 4</li>
                  <li>Calcul de la moyenne cumulative sur 5</li>
                  <li>Calcul de la moyenne cumulative sur 100</li>
                  <li>Conversion de GPA de 4 à 5 et vice versa</li>
                  <li>Conversion de GPA de 5 à 4 et vice versa</li>
                  <li>Conversion de GPA de 4 à 100 et vice versa</li>
                </ul>
              </div>
              <hr />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Calculer GPA sur 4{" "}
                  </h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="course">Matière (optionnel)</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="credits">Crédits</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      {" "}
                      <label htmlFor="grade">Note</label>
                    </b>
                  </div>
                </div>
                {courses.map((course, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        placeholder="Matière"
                        id="course"
                        value={course.name}
                        style={{ width: "100%", marginLeft: "4px" }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="credits"
                        placeholder="3"
                        id="credits"
                        value={course.credits}
                        className="form-control ml-2"
                        style={{ width: "100%", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <select
                        name="grade"
                        value={course.grade}
                        id="grade"
                        className="form-control ml-2"
                        style={{ width: "100%", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      >
                        {gradeOptions.map((option, gradeIndex) => (
                          <option key={gradeIndex} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <button
                        className="text-white btn bg-secondary"
                        onClick={() => removeCourse(index)}
                      >
                        Supprimer
                      </button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addCourse}
                >
                  Ajouter une matière
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculate}
                  disabled={isLoading}
                >
                  Calculer
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <br />
              {error && (
                <div className="alert alert-warning">
                  <b>
                    <u> Erreur :</u>
                  </b>{" "}
                  Veuillez entrer tous les champs correctement.{" "}
                </div>
              )}
              {gpa > 0 &&  (
                <div
                  style={{ fontSize: "19px" }}
                  className=" bg-light bg-gradient text-dark"
                >
                  <div className=" p-3   bg-success bg-gradient text-white">
                    <strong>Résultats</strong>
                  </div>
                  <div>
                    <table >
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td className="gpa-header">Moyenne cumulative</td>
                          <td>{gpa}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">Crédits totaux</td>
                          <td>{totalCredits}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">Évaluation</td>
                          <td>{calculateLetterGrade(gpa)}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">Évaluation numérique</td>
                          <td> {calculateNumericalGrade(gpa)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <GPAPlanner />
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPAto100 />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <Shared100toGPA />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to4 />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA4to5 />
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to100 />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <Shared100toGPA5 />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGradeUk />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GradeGPACalculator;
